<script lang="ts">
  import { inputLabels } from "../lang";
  import Tooltip from "./Tooltip.svelte";

  export let id: string;
  export let info = "";
</script>

<label class="Label" for={id}>
  <slot />

  {#if info}
    <span class="Label-info">
      <Tooltip label={inputLabels.info} text={info} />
    </span>
  {/if}
</label>

<style>
  .Label {
    color: var(--color-blue);
    display: inline-block;
    font-family: var(--font-family-decoration);
    font-weight: 500;
    margin-block-end: var(--size-8);
    position: relative;
    text-wrap: balance;
  }

  .Label-info {
    font-size: var(--size-16);
    margin-block-start: var(--size-2);
    margin-inline-start: var(--size-8);
    position: absolute;
  }
</style>
